import * as Icons from "lucide-react";
import { AMENITIES } from "@/data/property";
import { Reveal, MaskLineInView } from "./Reveal";

export default function Amenities() {
  return (
    <section id="amenities" data-testid="amenities-section" className="bg-[#F1E8DA] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="max-w-2xl mb-14">
          <span className="text-sm uppercase tracking-widest text-[#1FB6C9] font-body">Everything Included</span>
          <h2 className="mt-3 font-display font-semibold text-[#0E2A47] text-4xl md:text-6xl tracking-tight leading-none">
            <MaskLineInView>Resort-grade amenities</MaskLineInView>
          </h2>
          <p className="mt-5 text-[#0E2A47]/70 font-body text-lg">
            Perfect for groups — flexible dining, multiple lounges, and space to spread out. Crib and
            high chair available on request.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6">
          {AMENITIES.map((a, i) => {
            const Icon = Icons[a.icon] || Icons.Check;
            return (
              <Reveal key={a.label} delay={(i % 4) * 0.06}>
                <div
                  data-testid={`amenity-${i}`}
                  className="group h-full bg-[#FAFAF8] rounded-lg p-6 border border-[#0E2A47]/5 transition-all duration-400 hover:-translate-y-1 hover:shadow-xl hover:shadow-[#0E2A47]/5"
                >
                  <Icon size={26} strokeWidth={1.6} className="text-[#1FB6C9] transition-colors duration-300 group-hover:text-[#0E2A47]" />
                  <div className="mt-5 font-display font-medium text-[#0E2A47]">{a.label}</div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
